import YouTube from "react-youtube";

export default function FeaturedContent() {
    const opts = {
      height: "500", // vorher 390
      width: "900",  // vorher 640
      playerVars: {
        autoplay: 0,
      },
    };

    return (
        <section
            id="featured"
            className='mysection'
        >
            <h2 className='heading'>FEATURED</h2>

            <YouTube
                style={{
                  display: "flex",
                  justifyContent: "center",
                  paddingRight: "20px",
                  paddingLeft: "20px",
                }}
                videoId="RwufcIue_d4"
                opts={opts}
              />
        </section>

    );

}